/**
 * Hondo Hat Co. — product-media autoplay controller
 *
 * Starts only visible native Shopify product videos. Muted playback is required
 * for browser autoplay rules. The controller also pauses inactive/hidden gallery
 * copies and respects a visitor's reduced-motion preference.
 */
(function () {
  "use strict";

  var reduceMotionQuery = window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)")
    : null;
  var framePending = false;

  function prefersReducedMotion() {
    return Boolean(reduceMotionQuery && reduceMotionQuery.matches);
  }

  function isVisibleProductMedia(wrapper) {
    if (!wrapper || wrapper.hasAttribute("hidden")) return false;
    if (wrapper.classList.contains("swiper-slide") && !wrapper.classList.contains("swiper-slide-active")) return false;
    if (wrapper.classList.contains("hidden") || wrapper.closest("[hidden]")) return false;

    var style = window.getComputedStyle(wrapper);
    if (style.display === "none" || style.visibility === "hidden") return false;

    var rect = wrapper.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  }

  function syncAutoplay() {
    framePending = false;

    var videos = document.querySelectorAll('.media[data-autoplay-video="true"] video');
    for (var index = 0; index < videos.length; index += 1) {
      var video = videos[index];
      var wrapper = video.closest("[data-product-media-wrapper]");
      var shouldPlay = !prefersReducedMotion() && isVisibleProductMedia(wrapper);

      if (!shouldPlay) {
        if (!video.paused) video.pause();
        continue;
      }

      // The video is already muted initially for autoplay.
      // Do not reset muted here; that would override a customer's Unmute choice.
      video.playsInline = true;

      var playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === "function") {
        playAttempt.catch(function () {
          /* Autoplay may be declined by a browser or data-saver mode. */
        });
      }
    }
  }

  function scheduleSync() {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(syncAutoplay);
  }

  function observeGalleryState() {
    var galleries = document.querySelectorAll(".product__media-container");
    for (var index = 0; index < galleries.length; index += 1) {
      new MutationObserver(scheduleSync).observe(galleries[index], {
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "hidden"]
      });
    }
  }

  function initAutoplay() {
    observeGalleryState();
    scheduleSync();
    window.addEventListener("scroll", scheduleSync, { passive: true });
    window.addEventListener("resize", scheduleSync);
    document.addEventListener("visibilitychange", scheduleSync);
    document.addEventListener("shopify:section:load", function () {
      observeGalleryState();
      scheduleSync();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAutoplay);
  } else {
    initAutoplay();
  }
}());